(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["corner-coupon-price"] && !Shopify.designMode) return;
  try {
    (() => {
    const attached = new WeakSet();
    const formatYen = value => '¥' + new Intl.NumberFormat('ja-JP', { maximumFractionDigits: 0 }).format(value);
    function attach(root) {
      const blocks = root.matches?.('[data-corner-coupon]') ? [root] : root.querySelectorAll?.('[data-corner-coupon]') || [];
      for (const block of blocks) {
        if (attached.has(block)) continue;
        const wrapper = block.closest('.f-price');
        if (!wrapper) continue;
        attached.add(block);
        const sync = () => {
          const source = wrapper.classList.contains('f-price--on-sale') ? wrapper.querySelector('.f-price__sale .f-price-item--sale') : wrapper.querySelector('.f-price__regular .f-price-item--regular');
          const raw = source?.textContent?.match(/[0-9][0-9,]*(?:\.[0-9]+)?/);
          const yen = raw ? Number(raw[0].replaceAll(',', '')) : NaN;
          block.hidden = wrapper.classList.contains('f-price--sold-out') || !Number.isFinite(yen) || yen <= 0;
          if (block.hidden) return;
          const saved = Math.floor(yen * 5 / 100);
          const amount = block.querySelector('[data-corner-coupon-amount]');
          const saving = block.querySelector('[data-corner-coupon-saved]');
          if (amount.textContent !== formatYen(yen - saved)) amount.textContent = formatYen(yen - saved);
          if (saving.textContent !== formatYen(saved)) saving.textContent = formatYen(saved);
        };
        sync();
        new MutationObserver(sync).observe(wrapper, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['class'] });
      }
    }
    function start() {
      attach(document);
      const root = document.getElementById('MainContent') || document.body;
      new MutationObserver(records => {
        for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) attach(node);
      }).observe(root, { childList:true, subtree:true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true }); else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["corner-search-helper"] && !Shopify.designMode) return;
  try {
    (() => {
    const fields = 'title,vendor,product_type,variants.title,variants.sku,variants.barcode,tag';
    function normalize(value) {
      const text = String(value || '').normalize('NFKC').trim();
      if (/(?:^|\s)[a-z_][\w.]*:|\b(?:AND|OR|NOT)\b|"/.test(text)) return text;
      return text.replace(/クロム\s*ハーツ/gi, ' chrome hearts ').replace(/\bchrome[\s-]*hearts\b/gi, ' chrome hearts ').replace(/ゴローズ/g, " goro's ").replace(/\bgoro['’ʼ`]?s\b/gi, " goro's ").replace(/\s+/g, ' ').trim();
    }
    window.CornerSearch = Object.freeze({ normalize, fields });
    function setInput(form, name, value) {
      let input = Array.from(form.elements).find(item => item.name === name);
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.appendChild(input); }
      input.value = value;
    }
    document.addEventListener('submit', event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !/\/search\/?$/.test(new URL(form.action, location.href).pathname)) return;
      const input = Array.from(form.elements).find(item => item.name === 'q');
      if (!input || !input.value.trim()) return;
      const original = input.value.trim();
      input.value = normalize(original);
      setInput(form, 'type', 'product');
      setInput(form, 'options[fields]', fields);
      setInput(form, 'options[unavailable_products]', 'last');
      setInput(form, 'corner_query', original);
    }, true);
    function start() {
      if (!/\/search\/?$/.test(location.pathname)) return;
      const url = new URL(location.href);
      const query = url.searchParams.get('q');
      if (!query?.trim()) return;
      const normalized = normalize(query);
      const changed = normalized !== query || url.searchParams.get('options[fields]') !== fields || url.searchParams.get('type') !== 'product';
      if (changed) {
        if (normalized !== query) { url.searchParams.set('corner_query', query); url.searchParams.delete('page'); }
        url.searchParams.set('q', normalized);
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[fields]', fields);
        url.searchParams.set('options[unavailable_products]', 'last');
        location.replace(url.href);
        return;
      }
      const original = url.searchParams.get('corner_query');
      if (!original || normalize(original) !== query) return;
      for (const input of document.querySelectorAll('form[action] [name="q"]')) input.value = original;
      for (const node of document.querySelectorAll('[data-corner-search-heading], .sf-search-page__no-results')) {
        const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
        let text;
        while ((text = walker.nextNode())) if (text.nodeValue.includes(query)) text.nodeValue = text.nodeValue.replaceAll(query, original);
      }
      document.title = document.title.replaceAll(query, original);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true }); else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
